export const installMobileAppBannerLayerPath = 'install-mobile-app-banner'
